//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        disableLine: {
            type: Boolean,
            default: true,
        },
        wrapperClass: {
            type: Boolean,
            default: true,
        },
    },
    computed:{
        /** @return {string[]} */
        availableLangs() {
            /** @type {string[]} */
            const langs = [];
            for (const locale of this.$i18n.locales) {
                langs.push(typeof(locale) === 'string' ? locale : locale.lang);
            }
            return langs;
        },
    },
    methods: {
        /**
         * @param {string} translationKey
         * @return {string} The translation.
         */
        getTranslation(translationKey) {
            return /** @type {string} */ (this.$t(`webCommon.footer.${translationKey}`));
        },
        /**
         * @param {string} locale The locale
         */
        onLanguageChanged(locale) {
            this.$i18n.setLocale(locale);
        },
    },
};
